import { SmartLinkWidgetType } from 'fym-common/src/db/enums';
import { SerializedWidget } from 'fym-common/src/db/serializersTypes';

/** The "New" tag of an auto-added Bio Link block stays 7 days (design e3). */
export const AUTO_ADDED_NEW_DAYS = 7;

const DAY_MS = 24 * 60 * 60 * 1000;

/**
 * When the Bio Link auto add put a Catalog links block on the page (`data.autoAddedAt`, ISO), or
 * null. The serialised presave data type has no field for it yet, so it is read as an optional
 * extra field of the answer.
 */
export function autoAddedAtOf(widget: SerializedWidget): string | null {
  if (widget.type !== SmartLinkWidgetType.presave) {
    return null;
  }
  const value = (widget.data as { autoAddedAt?: unknown }).autoAddedAt;
  return typeof value === 'string' && !Number.isNaN(Date.parse(value)) ? value : null;
}

/** True while an auto-added block shows the "New" tag. */
export function isNewAutoAdded(widget: SerializedWidget, now: number = Date.now()): boolean {
  const at = autoAddedAtOf(widget);
  if (at === null) {
    return false;
  }
  const age = now - Date.parse(at);
  return age >= 0 && age < AUTO_ADDED_NEW_DAYS * DAY_MS;
}

/** The newest auto-added block of the page, for the note after an auto add (design e3). */
export function newestAutoAdded(
  widgets: readonly SerializedWidget[],
  now: number = Date.now()
): { widget: SerializedWidget; at: string } | null {
  return widgets.reduce<{ widget: SerializedWidget; at: string } | null>((newest, widget) => {
    const at = autoAddedAtOf(widget);
    if (at === null || !isNewAutoAdded(widget, now)) {
      return newest;
    }
    return newest === null || at > newest.at ? { widget, at } : newest;
  }, null);
}
